import { createApp } from 'vue'
import App from './App'

// createApp(App).mount('#app')
const app = createApp(App)

// import { BootstrapVue, IconsPlugin } from '/node_modules/bootstrap-vue/dist/bootstrap-vue.js'

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-vue/dist/bootstrap-vue-icons.css'

app.directive('phone', {
    bind(el) { 
      function replaceNumberForInput(value) {
        let val = ''
        const x = value.replace(/\D/g, '').match(/(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,4})/)

        if (!x[2] && x[1] !== '') {
          val = x[1] === '8' ? x[1] : '8' + x[1]
        } else {
          val = !x[3] ? x[1] + x[2] : x[1] + '(' + x[2] + ') ' + x[3] + (x[4] ? '-' + x[4] : '')
        }

        return val
      }

      function replaceNumberForPaste(value) {
        const r = value.replace(/\D/g, '')
        let val = r
        if (val.charAt(0) === '7') {
          val = '8' + val.slice(1)
        }
        return replaceNumberForInput(val)
      }

      el.oninput = function(e) {
        if (!e.isTrusted) {
          return
        }
        this.value = replaceNumberForInput(this.value)
      }

      el.onpaste = function() {
        setTimeout(() => {
          const pasteVal = el.value
          this.value = replaceNumberForPaste(pasteVal)
        })
      }

    }
})

// Регистрируем глобальную пользовательскую директиву `v-focus`
app.directive('focus', {
    // Когда привязанный элемент будет примонтирован в DOM...
    mounted(el) {
      // Переключаем фокус на элемент
      el.focus()
    }
})

app
    // .use(BootstrapVue)
    // .use(IconsPlugin)
    .mount('#app');